(function(){
  'use strict';
  var root = ((window.Arca && window.Arca.root) || '/').replace(/\/?$/, '/');

  /* Desktop dropdown menus: hover opens, a click opens and keeps them open; click outside or Esc closes */
  var megas = [].slice.call(document.querySelectorAll('.a-has-mega'));
  function closeAll(except){ megas.forEach(function(li){ if (li !== except) { li.classList.remove('is-open'); var a = li.querySelector(':scope > a'); if (a) a.setAttribute('aria-expanded', 'false'); } }); }
  megas.forEach(function(li){
    var a = li.querySelector(':scope > a');
    if (!a) return;
    a.setAttribute('aria-haspopup', 'true');
    a.setAttribute('aria-expanded', 'false');
    a.addEventListener('click', function(e){
      if (!li.classList.contains('is-open')) {
        e.preventDefault();
        closeAll(li);
        li.classList.add('is-open');
        a.setAttribute('aria-expanded', 'true');
      }
    });
    var t;
    li.addEventListener('mouseleave', function(){ t = setTimeout(function(){ li.classList.remove('is-open'); a.setAttribute('aria-expanded', 'false'); }, 250); });
    li.addEventListener('mouseenter', function(){ clearTimeout(t); closeAll(li); });
  });
  document.addEventListener('click', function(e){ if (!e.target.closest('.a-has-mega')) closeAll(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });

  /* Best sellers limited to jewelry and scarves */
  var allowedCache = null;
  function allowed(handles){
    if (allowedCache) return allowedCache;
    allowedCache = Promise.all(handles.map(function(h){
      return fetch(root + 'collections/' + h + '/products.json?limit=250').then(function(r){ return r.ok ? r.json() : {products: []}; }).then(function(d){ return (d.products || []).map(function(p){ return p.handle; }); }).catch(function(){ return []; });
    })).then(function(lists){ var set = {}; lists.forEach(function(l){ l.forEach(function(h){ set[h] = 1; }); }); return set; });
    return allowedCache;
  }
  function handleOf(card){ var a = card.querySelector('a[href*="/products/"]'); if (!a) return ''; var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/); return m ? m[1] : ''; }
  document.querySelectorAll('[data-arca-best]').forEach(function(el){
    var handles = (el.getAttribute('data-arca-best') || 'rings,earrings,necklaces,bracelets,sets,scarves').split(',');
    var limit = parseInt(el.getAttribute('data-limit') || '4', 10);
    var step = limit;
    var more = el.parentNode.querySelector('[data-arca-best-more]');
    var page = 1, done = false, busy = false, seen = {};
    function fill(){
      if (busy) return; busy = true;
      if (more) more.textContent = 'Loading…';
      allowed(handles).then(function(ok){
        function next(){
          if (done || el.querySelectorAll('.a-card').length >= limit) { busy = false; if (more) { more.textContent = 'Load more'; more.hidden = done; } return; }
          fetch(root + 'collections/all?sort_by=best-selling&page=' + page + '&section_id=arca-collection').then(function(r){ return r.text(); }).then(function(html){
            page++;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelectorAll('#ArcaGrid .a-card');
            if (!cards.length || page > 30) done = true;
            [].forEach.call(cards, function(c){
              if (el.querySelectorAll('.a-card').length >= limit) return;
              var h = handleOf(c);
              if (!h || !ok[h] || seen[h] || c.querySelector('.a-badge--sold')) return;
              seen[h] = 1; el.appendChild(document.importNode(c, true));
            });
            next();
          }).catch(function(){ done = true; next(); });
        }
        next();
      });
    }
    if (more) more.addEventListener('click', function(e){ e.preventDefault(); limit += step; fill(); });
    fill();
  });
})();
